export default "__VITE_ASSET__Dk$JR1vX__"